import { createSlice } from '@reduxjs/toolkit';

export const errorSlice = createSlice({
    name: 'errors',
    initialState: {
        notFound: false,
    },
    reducers: {
        setNotFound: (state, action) => {
            state.notFound = action.payload;
        },
    },
});

export const { setNotFound } = errorSlice.actions;

export default errorSlice.reducer;
